module.exports = __webpack_public_path__ + "static/img/head-id.ab36abd4.png";